import React from 'react';
import PropTypes from 'prop-types';

import { Scope } from 'informed';
import { Cell, Grid } from 'react-md';
import { get } from 'lodash-es';

import DatePickerGenericField from '../../Common/DatePickerGenericField';
import HiddenField from '../../Common/HiddenField';
import Select from '../../Common/Select';
import TextField from '../../Common/TextField';

import { isEmail, isPhone, isDateValid } from '../Transform/utils';

const PartyFieldsComponent = ({ config, strings, readOnly }) => {
  const isValidPhone = phone => {
    const status = isPhone(phone);
    const message = get(strings, 'validation.message.invalid_phone', 'Numéro de téléphone non valide');
    return { status, message };
  };
  const isValidEmail = email => {
    const status = isEmail(email);
    const message = get(strings, 'validation.message.invalid_email', 'Adresse mail non valide');
    return { status, message };
  };
  const isValidBirthDate = birthDate => {
    const status = isDateValid(birthDate);
    const message = get(strings, 'validation.message.invalid_birthDate', 'Date de naissance non valide');
    return { status, message };
  };

  return (
    <Grid className="grid party">
      <Scope scope="party">
        <div
          key="gender"
          className={Cell.getClassName({ size: 1 })}
          style={{
            minWidth: '65px',
            maxWidth: '80px',
          }}
        >
          <Select
            className="field select"
            key="gender"
            field="gender"
            id="select-gender"
            name="gender"
            shrink
            label={strings['block.covered.party.field.gender.label']}
            options={config.covered.genders.options}
            disabled={readOnly}
            required
          />
        </div>
        <div key="name" className={Cell.getClassName({ size: 4 })}>
          <TextField
            className="field text"
            key="name"
            field="name"
            id="numberfield-name"
            name="name"
            shrink
            label={strings['block.covered.party.field.name.label']}
            placeholder=""
            disabled={readOnly}
            required
          />
        </div>
        <div key="first_name" className={Cell.getClassName({ size: 4 })}>
          <TextField
            className="field text"
            key="first_name"
            field="first_name"
            id="numberfield-first_name"
            name="first_name"
            shrink
            label={strings['block.covered.party.field.first_name.label']}
            placeholder=""
            disabled={readOnly}
            required
          />
        </div>
        <div key="birth_date" className={Cell.getClassName({ size: 3 })}>
          <DatePickerGenericField
            type="date"
            className="field text"
            key="birth_date"
            field="birth_date"
            id="numberfield-birth_date"
            name="birth_date"
            shrink
            label={strings['block.covered.party.field.birth_date.label']}
            errorLabel={strings['error.date']}
            placeholder="JJ/MM/AAAA"
            disabled={readOnly}
            required
            validation={isValidBirthDate}
          />
        </div>
        {/* PHONE */}
        <div key="phone" className={Cell.getClassName({ size: 3 })}>
          <TextField
            className="field text"
            key="phone"
            field="phone"
            id="field-phone"
            name="phone"
            shrink
            label={strings['block.transform.party.field.phone.label']}
            placeholder=""
            disabled={readOnly}
            required
            validation={isValidPhone}
            strings={strings}
          />
        </div>
        {/* EMAIL */}
        <div key="email" className={Cell.getClassName({ size: 4 })}>
          <TextField
            className="field text"
            key="email"
            field="email"
            id="field-email"
            name="email"
            shrink
            label={strings['block.transform.party.field.email.label']}
            placeholder=""
            disabled={readOnly}
            required
            validation={isValidEmail}
            strings={strings}
          />
        </div>
        <HiddenField key="subscriber.is_person" value field="is_person" initialValue />
      </Scope>
    </Grid>
  );
};

PartyFieldsComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  config: PropTypes.any.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

PartyFieldsComponent.defaultProps = {};

export default PartyFieldsComponent;
